"use client";

import "@/css/landing.css";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

import { useAuth } from "@/app/context/AuthContext";
import HomeComponent from "@/components/Home/Home";

export default function Home() {
    const router = useRouter();
    const { refreshAuth } = useAuth();

    useEffect(() => {
        refreshAuth().then((ok) => {
            if (ok) {
                router.replace('/overview');
                return;
            }
            (window as any).hidePreloader?.();
        });
    }, [refreshAuth, router]);

    return <HomeComponent />;
}
